import { Controller } from '@hotwired/stimulus'

// Shows a spinner on the submit button and blocks repeat submits
// until the next page load.
export default class extends Controller {
  static targets = ['button', 'label', 'spinner']

  connect() {
    window.addEventListener('pageshow', this.reset)
  }

  disconnect() {
    window.removeEventListener('pageshow', this.reset)
  }

  submit = (event) => {
    if (this.submitting) {
      event.preventDefault()
      return
    }

    this.submitting = true
    this.buttonTarget.disabled = true
    this.buttonTarget.setAttribute('aria-busy', 'true')
    this.labelTarget.textContent = this.buttonTarget.dataset.loadingText || 'Searching…'
    this.spinnerTarget.classList.remove('hidden')
  }

  // Restores the button when the page comes back from the back/forward cache
  reset = () => {
    this.submitting = false
    this.buttonTarget.disabled = false
    this.buttonTarget.removeAttribute('aria-busy')
    this.labelTarget.textContent = this.buttonTarget.dataset.defaultText
    this.spinnerTarget.classList.add('hidden')
  }
}
